import { Box, Container, Grid, Stack, Typography } from "@mui/material";
import React from "react";
import COLORS from "../../../constants/colors";
import { ArticlePreview } from "../../../interfaces/sanity/sanityClasses";
import ArticleCard from "../Article/ArticleCard";
import ArrowRightLink from "../../navigation/ArrowRightLink";
import Display from "../../layout/Display";
import useIsMobile from "../../../hooks/useIsMobile";
import ArticleCardGrid from "../../ArticleCardGrid";

interface Props {
  articles: {
    node: ArticlePreview;
  }[];
}

const MostReadArticlesShowcase = ({ articles }: Props) => {
  const isMobile = useIsMobile();

  return (
    <section>
      <Box sx={{ paddingY: "80px" }}>
        <Container>
          <Stack gap="56px">
            <Stack
              direction="row"
              justifyContent="space-between"
              alignItems="flex-end"
            >
              <Typography
                fontFamily="Erlik"
                color={COLORS.BRIGHT_BLUE[60]}
                variant="h2"
              >
                AKTUELT
              </Typography>
              <Display desktop>
                <ArrowRightLink
                  href="/artikler"
                  text="Alle artikler"
                  color="secondary"
                />
              </Display>
              <Display mobile>
                <ArrowRightLink
                  href="/artikler"
                  text="Se alle"
                  color="secondary"
                />
              </Display>
            </Stack>
            <ArticleCardGrid articles={articles} />
          </Stack>
        </Container>
      </Box>
    </section>
  );
};
export default MostReadArticlesShowcase;
